import Keyword from './Keyword';

export default class NumberKeyword extends Keyword {}
